"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _label = _interopRequireDefault(require("./style/label"));

var _labelHolder = _interopRequireDefault(require("./style/labelHolder"));

var _root = _interopRequireDefault(require("./style/root"));

var _react = _interopRequireWildcard(require("react"));

var _input = _interopRequireDefault(require("./style/input"));

var _border = _interopRequireDefault(require("./style/border"));

var _Underscore = _interopRequireDefault(require("../Underscore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _extractStates = _interopRequireDefault(require("../style/extractStates"));

var _getState = _interopRequireDefault(require("../style/getState"));

var _globals = require("../../globals.js");

var _isNativeBorder = _interopRequireDefault(require("./utils/isNativeBorder"));

var _themeBus = _interopRequireDefault(require("./theme/themeBus"));

var _deprecatedThemeProps = _interopRequireDefault(require("./theme/deprecatedThemeProps"));

var _theme = _interopRequireDefault(require("./theme"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// its faster then recompile all styles 16.01.2020
var MemoLabel = _react["default"].memo(_label["default"]);

var MemoInput = _react["default"].memo(_react["default"].forwardRef(function (props, ref) {
  return _react["default"].createElement(_input["default"], (0, _extends2["default"])({}, props, {
    ref: ref
  }));
}));

var MemoBorder = _react["default"].memo(_Underscore["default"]);

var Input = _react["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      value = _ref.value,
      error = _ref.error,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      onBlur = _ref.onBlur,
      floating = _ref.floating,
      clearPresetValue = _ref.clearPresetValue,
      elementRef = _ref.elementRef,
      cropLabel = _ref.cropLabel,
      style = _ref.style,
      theme = _ref.theme,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      defaultValue = _ref.defaultValue,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      underscore = _ref.underscore,
      className = _ref.className,
      attribute = _ref.attribute,
      name = _ref.name,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["label", "value", "error", "onFocus", "onChange", "placeholder", "onBlur", "floating", "clearPresetValue", "elementRef", "cropLabel", "style", "theme", "disabled", "readOnly", "defaultValue", "onMouseEnter", "onMouseLeave", "underscore", "className", "attribute", "name"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1],
      _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1],
      _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      autoClear = _useState6[0],
      setAutoClear = _useState6[1],
      input = (0, _react.useRef)(null),
      handleEnter = (0, _react.useCallback)(function (e) {
    setHover(true);

    if (typeof onMouseEnter === 'function') {
      onMouseEnter(e);
    }
  }, [onMouseEnter]),
      handleLeave = (0, _react.useCallback)(function (e) {
    setHover(false);

    if (typeof onMouseLeave === 'function') {
      onMouseLeave(e);
    }
  }, [onMouseLeave]),
      handleFocus = (0, _react.useCallback)(function (e) {
    setFocus(true);

    if (typeof onFocus === 'function') {
      onFocus(e);
    }

    if (clearPresetValue && !autoClear && input.current) {
      input.current.value = '';
      onChange((0, _syntheticEvent["default"])(input.current));
      setAutoClear(true);
    }
  }, [onFocus, onChange, autoClear]),
      handleBlur = (0, _react.useCallback)(function (e) {
    setFocus(false);

    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  }, [onBlur]);

  value = value === null ? '' : value;
  defaultValue = defaultValue === null ? '' : defaultValue; // upgrade focus method

  (0, _react.useEffect)(function () {
    if (input === null || input === void 0 ? void 0 : input.current) {
      var proto = Object.getPrototypeOf(input.current);

      input.current.focus = function () {
        var _value;

        proto.focus.call(input.current);

        if ((_value = value) === null || _value === void 0 ? void 0 : _value.length) {
          try {
            input.current.selectionStart = value.length;
          } catch (e) {
            if (process && process.env.NODE_ENV !== 'production') {
              window.console.error("Web-components: Input ".concat(e));
            }
          }
        }
      };
    }
  }, []); // add refs

  (0, _react.useEffect)(function () {
    if (ref) {
      ref.current = input.current;
    }

    if (typeof elementRef === 'function') {
      elementRef(input.current);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = input.current;
    }

    return function () {
      if (ref) {
        ref.current = null;
      }

      if (typeof elementRef === 'function') {
        elementRef(null);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = null;
      }
    };
  }, [ref, elementRef]);
  var styles = (0, _react.useMemo)(function () {
    // todo remove in next major version. current 9.8
    if (theme) {
      var props = Object.keys(theme);

      if (!!props.find(function (key) {
        return _deprecatedThemeProps["default"].includes(key);
      })) {
        console.info('Web components. Input. Deprecated theme property was passed.');
        theme = (0, _deepmerge["default"])((0, _theme["default"])(theme.palette), (0, _themeBus["default"])(theme));
      }
    }

    if (style) {
      var _props = Object.keys(style);

      if (!!_props.find(function (key) {
        return _deprecatedThemeProps["default"].includes(key);
      })) {
        console.info('Web components. Input. Deprecated theme property was passed.');
        style = (0, _themeBus["default"])(style);
      }
    }

    var compiled = (0, _mergeTheme["default"])(theme, style);
    return {
      input: (0, _extractStates["default"])(_objectSpread({}, compiled, {
        label: undefined,
        underscore: undefined
      })),
      label: (0, _extractStates["default"])(compiled.label),
      // extract state inside Underscore
      underscore: compiled.underscore
    };
  }, [theme, style]);
  var state = (0, _react.useMemo)(function () {
    return (0, _getState["default"])({
      hover: hover,
      focus: focus,
      error: error,
      disabled: disabled
    });
  }, [hover, focus, error, disabled]);
  return _react["default"].createElement(_root["default"], {
    onMouseEnter: handleEnter,
    onMouseLeave: handleLeave,
    theme: styles.input[state],
    className: className
  }, label ? _react["default"].createElement("div", null, _react["default"].createElement(_labelHolder["default"], {
    theme: styles.label[state]
  }, "\xA0"), _react["default"].createElement(MemoLabel, {
    crop: cropLabel,
    theme: styles.label[state],
    states: styles.label,
    focus: focus,
    error: error,
    top: focus || value !== '' && value !== undefined || defaultValue !== '' && defaultValue !== undefined,
    floatToFontSize: styles.input[_globals.STATE.IDLE].fontSize,
    floatToLineHeight: styles.input[_globals.STATE.IDLE].lineHeight,
    floatToPaddingLeft: styles.input[_globals.STATE.IDLE].paddingLeft,
    floatToPaddingRight: styles.input[_globals.STATE.IDLE].paddingRight,
    floatToPaddingTop: styles.input[_globals.STATE.IDLE].paddingTop,
    floating: floating
  }, label)) : null, _react["default"].createElement("div", null, _react["default"].createElement(MemoInput, (0, _extends2["default"])({}, rest, {
    theme: styles.input[state],
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: input,
    placeholder: focus || !floating || !label ? placeholder : '',
    disabled: disabled,
    readOnly: readOnly,
    defaultValue: defaultValue,
    value: value,
    onChange: onChange,
    "data-qa-node": name || attribute,
    "data-qa-value": value,
    name: name
  }))), _react["default"].createElement(_border["default"], null, underscore && !(0, _isNativeBorder["default"])(styles.input[state].borderStyle) ? _react["default"].createElement(MemoBorder, {
    state: state,
    style: styles === null || styles === void 0 ? void 0 : styles.underscore
  }) : null));
});

Input.displayName = 'Input';
Input.defaultProps = {
  floating: true,
  error: false,
  cropLabel: false,
  underscore: true
};
Input.propTypes = {
  label: _propTypes["default"].any,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  error: _propTypes["default"].bool,
  floating: _propTypes["default"].bool,
  cropLabel: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  style: _propTypes["default"].object,
  underscore: _propTypes["default"].bool,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  clearPresetValue: _propTypes["default"].bool
};
var _default = Input;
exports["default"] = _default;